import { initSection } from '../../core/shopify/init-section/index.js';
const NAMESPACE = '.GiftGuideNav-section';
const ACTIVE_CLASS = 'GiftGuideNav-link--active';
const parameterize = (text)=>text.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
initSection(NAMESPACE, (section)=>{
    const nav = section.querySelector('.GiftGuideNav');
    const links = Array.from(section.querySelectorAll('.GiftGuideNav-link'));
    if (!nav || links.length === 0) return {
        unload: null
    };
    const scrollToTarget = (id)=>{
        const target = document.querySelector(`[data-anchor="${id}"]`);
        if (!target) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const top = target.getBoundingClientRect().top + window.scrollY - nav.getBoundingClientRect().height;
        window.scrollTo({
            top,
            behavior: reducedMotion ? 'auto' : 'smooth'
        });
    };
    var _link_dataset_id;
    const entries = links.map((link)=>({
            link,
            id: parameterize((_link_dataset_id = link.dataset.id) !== null && _link_dataset_id !== void 0 ? _link_dataset_id : '')
        }));
    // The current slot is the last one whose top has reached the sticky nav
    // (top <= nav height), i.e. the closest to it from above. The extra pixel
    // absorbs sub-pixel rounding after a smooth scroll.
    const updateActiveLink = ()=>{
        let activeLink = null;
        let nearestTop = -Infinity;
        const limit = nav.getBoundingClientRect().height + 1;
        entries.forEach(({ link , id  })=>{
            const target = id ? document.querySelector(`[data-anchor="${id}"]`) : null;
            const top = target === null || target === void 0 ? void 0 : target.getBoundingClientRect().top;
            if (top !== undefined && top <= limit && top > nearestTop) {
                nearestTop = top;
                activeLink = link;
            }
        });
        links.forEach((link)=>{
            link.classList.toggle(ACTIVE_CLASS, link === activeLink);
        });
    };
    let frame = 0;
    const onScroll = ()=>{
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(updateActiveLink);
    };
    const listeners = entries.map(({ link , id  })=>{
        const onClick = (evt)=>{
            evt.preventDefault();
            if (id) scrollToTarget(id);
            updateActiveLink();
        };
        link.addEventListener('click', onClick);
        return ()=>link.removeEventListener('click', onClick);
    });
    window.addEventListener('scroll', onScroll, {
        passive: true
    });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    updateActiveLink();
    return {
        unload: ()=>{
            cancelAnimationFrame(frame);
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
            window.removeEventListener('load', onScroll);
            listeners.forEach((removeListener)=>removeListener());
        }
    };
});
